import type { JSONValue } from '@kizenapps/engine';

export const planFromActiveLicenses = (
  activeLicenses:
    | Record<string, { features?: Record<string, JSONValue> }>
    | undefined
): Record<string, Record<string, JSONValue>> => {
  const result: Record<string, Record<string, JSONValue>> = {};

  Object.entries(activeLicenses ?? {}).forEach(([category, license]) => {
    if (license?.features) {
      result[category] = license.features;
    }
  });

  return result;
};
